import { getPestModelColumns } from 'App/Map/PanelDetails/OverviewCharts/_utils/pestModelColumns'
import { trapCatchesColumns } from 'App/Map/PanelDetails/OverviewCharts/_utils/trapCatchesColumns'
import type { TValueGroupColumns } from 'App/Map/PanelDetails/OverviewCharts/_utils/types'

export const getPestsColumns = (
  valueGroup: string,
  insectIds: number[] | null,
): TValueGroupColumns | undefined => {
  if (!insectIds) return undefined

  if (valueGroup === 'trap_catches') return trapCatchesColumns

  const insectId = insectIds.find((id) => valueGroup === `pest_${id}`)

  return insectId === undefined ? undefined : getPestModelColumns(insectId)
}
